import * as React from 'react'
import { Button } from '../../components/UI/Button'
import { Link } from 'gatsby'
import { StyledBodyMain, StyledButtons, StyledDescription, StyledDisturber, StyledHeadline } from './styled'
import { useI18n } from '../../lib/context/i18n'
import { sbEditable } from '@storyblok/storyblok-editable'

export const DisturberBlog = ({ blok }) => {
  const { getTranslatedUrlFromLink } = useI18n()

  return (
    <StyledDisturber className={blok.theme && `theme-${blok.theme}`} {...sbEditable(blok)}>
      <StyledBodyMain>
        <StyledHeadline>{blok.title}</StyledHeadline>
        <StyledDescription>{blok.description}</StyledDescription>
      </StyledBodyMain>
      {blok.buttons && (
        <StyledButtons>
          {blok.buttons?.map(button => {
            return (
              <Button
                key={button._uid}
                as={Link}
                to={
                  button.product_code
                    ? `${getTranslatedUrlFromLink(button.link)}?product_code=${button.product_code}`
                    : getTranslatedUrlFromLink(button.link)
                }
                $variant={button.button_style}
                title={button.link_title}
                $inverted
              >
                {button.button_name}
              </Button>
            )
          })}
        </StyledButtons>
      )}
    </StyledDisturber>
  )
}
